import { GLEnvironment, GrowelabEnv } from 'src/app/common/types/env';
import { environment as defaultEnv } from './environment.default';

export const environment: GrowelabEnv = {
  ...defaultEnv,
  environment: GLEnvironment.PRODUCTION,
  production: true,
  apiUrl: 'https://api.engage2learn.org',
  glaiApiUrl: 'https://ai.growelab.app/api/v1', // URL of GLAI API backend
  pusher: {
    key: '93c330587b3cc316c630',
    cluster: 'us2',
  },
  googleAnalyticsID: 'G-1KG6HW8SPK',
  googleOAuthClientId:
    '655769197706-e0sottrdhhe70afclmlele29lv7op1ju.apps.googleusercontent.com',
  SENTRY_ORG: 'engage2learn',
  SENTRY_PROJECT: 'growelab-web',
  SENTRY_KEY:
    '519b763d3b944feb82e5349b62abae25d6c7b66c6c8e41db87275eaa884d75dc',
  cleverClientId: 'bbb0654f1a928e5baa80',
  cleverRedirectURI: 'https://www.growelab.app/clever-auth',
  unleash: {
    url: 'https://us.app.unleash-hosted.com/usgg0020/api/frontend',
    clientKey:
      'default:production.976f79c3842e3ae625991c773c93ac887217ee020c619cb5cb611375',
  },
  getstream_appid: '1292588',
  getstream_key: 'dhjvudk4c63t',
  ckEditor: {
    ...defaultEnv.ckEditor,
    // Production license key
    licenseKey:
      'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MDEzNTM1OTksImp0aSI6IjYxZDE1ZmQ4LTE2NzctNDZmMC05OGEzLTVlZDM3NTUzMWI4NSIsImxpY2Vuc2VkSG9zdHMiOlsiKi5ncm93ZWxhYi5hcHAiLCIqLmVuZ2FnZTJsZWFybi5vcmciXSwidXNhZ2VFbmRwb2ludCI6Imh0dHBzOi8vcHJveHktZXZlbnQuY2tlZGl0b3IuY29tIiwiZGlzdHJpYnV0aW9uQ2hhbm5lbCI6WyJjbG91ZCIsImRydXBhbCJdLCJ3aGl0ZUxhYmVsIjp0cnVlLCJmZWF0dXJlcyI6WyJEUlVQIiwiRE8iLCJGUCIsIlNDIiwiVE9DIiwiVFBMIiwiUE9FIiwiQ0MiLCJNRiIsIlNFRSIsIkVDSCIsIkVJUyIsIkxIIiwiRk9PIiwiUkUiLCJSQ01UIiwiUlRDIl0sInZjIjoiODI2MzYzNmEifQ.lSra3vGP7KFL1dH9ioxMvLUBU9sZrY00CRk6m9Tjmaph28KuSSusfcV47j6_axp1SPCvnbeXpmv943rRz8dnqA',
    environmentId: '-JeAmvFi63Mw1vU4bXPN',
  },
};
